import * as React from 'react';
import Select from 'antd/lib/select';
import { ISelectorData } from '../../Components/Selector';

export interface ISelectorProducerProps {
	onSelected: (selected: string[]) => void;
	selected: string[];
	data: ISelectorData[];
}

const SelectorProducer = (props: ISelectorProducerProps) => (<Select
					notFoundContent="Minera no encontrada"
					mode="multiple"
					placeholder="Seleccione las mineras ha asociar"
					optionFilterProp="children"
					filterOption={(input, option) => {
						if (!option.props.children) {
							return false;
						}
						const arg = option.props.children as string;
						return arg.toLowerCase().indexOf(input.toLowerCase()) >= 0
					}}
					onChange={props.onSelected}
					value={props.selected} >
					{props.data.map(psd => (<Select.Option
						key={psd.value}
						value={psd.value}>
						{psd.label}
					</Select.Option>)
					)}
				</Select>);

export default SelectorProducer;
